import { getPackageBlob } from "../api/general";

export const DownloadArtifact = async (id: string, type: string) => {
    const res = await getPackageBlob(
        `api/conversions/artifacts/${id}?type=${type}`
    );
    return res;
};